import { Api } from "./Api";
import { Setting } from "../models/Setting";
import axios from "axios";

export class SettingApi extends Api {
    constructor() {
        super("app/setting");
    }

    get(key: string, params?: Object): Promise<Setting> {
        return axios
            .get(this.apiUrl + key, { params: params })
            .then(function (response) {
                let res: Setting = { key: key, value: "" };
                if (response.data) {
                    res = response.data;
                }
                return res;
            });
    }

    set(setting: Setting, params?: Object): Promise<Setting> {
        return axios
            .put(this.apiUrl + setting.key, setting, { params: params })
            .then(function (response) {
                let res: Setting = setting;
                if (response.data) {
                    res = response.data;
                }
                return res;
            });
    }

    uploadLogo(file: File): Promise<any> {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(this.apiUrl + "logo", formData);
    }
}
